var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSuperLikeCarouselProspects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSuperLikeCarouselProspects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.0659139,16.0064075 C35.7576444,15.3370815 36.001826,14.3547513 35.70346,13.4415894 C35.4043904,12.5284275 34.6254018,11.8765683 33.6683789,11.7382316 L25.159319,10.5106682 C24.7969169,10.4582679 24.4837734,10.2325974 24.3219239,9.90631849 L20.5177577,2.25168845 C20.0906159,1.39162551 19.2236657,0.857142857 18.2574947,0.857142857 C17.2920274,0.857142857 16.4250772,1.39162551 15.9979354,2.25168845 L12.1930655,9.90701716 C12.031216,10.2332961 11.7173688,10.4589666 11.3549667,10.5113668 L2.84590682,11.7389303 C1.88958756,11.8765683 1.10989534,12.5291262 0.810825669,13.4422881 C0.512459692,14.3554499 0.756641282,15.3377801 1.44837184,16.0071061 L7.60498489,21.9653651 C7.86746251,22.219681 7.98779407,22.5857842 7.92586905,22.9435033 L6.47344599,31.3568891 C6.34467011,32.0974794 6.54029686,32.8178083 7.02303049,33.3858271 C7.7731676,34.2710422 9.08274091,34.5407289 10.1298366,33.9943688 L17.7395764,30.0217304 C18.0576458,29.8561456 18.4580473,29.857543 18.775413,30.0217304 L26.3858565,33.9943688 C26.7559992,34.1879005 27.1507712,34.2857143 27.5582096,34.2857143 C28.3020135,34.2857143 29.0071142,33.9573393 29.4919589,33.3858271 C29.9753962,32.8178083 30.1703193,32.0960821 30.0415434,31.3568891 L28.5884167,22.9435033 C28.5264916,22.5850855 28.6468232,22.219681 28.9093008,21.9653651 L35.0659139,16.0064075 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Likes-Swipe-Copy",
    transform: "translate(-158.000000, -1427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icSuperLikeCarouselProspects",
    transform: "translate(158.000000, 1427.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,1 C14.0525577,1 1,14.0525577 1,30 C1,45.9474423 14.0525577,59 30,59 C45.9474423,59 59,45.9474423 59,30 C59,14.0525577 45.9474423,1 30,1 Z",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    transform: "translate(30.000000, 30.000000) rotate(-360.000000) translate(-30.000000, -30.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(12.171429, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#10C2E1",
    strokeWidth: 2,
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuperLikeCarouselProspects);
export default __webpack_public_path__ + "static/media/icSuperLikeCarouselProspects.a4e81bba982b09f3d4b7c7f6416f7166.svg";
export { ForwardRef as ReactComponent };